import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';

const TilesWrapper = styled.div`
  display: flex;
  grid-gap: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_6B};

  ${mediaQuery.uptoMobile} {
    gap: ${Spacings.SPACING_3B};
    flex-direction: column;
  }
`;

const SubscriptionTiles = styled.div`
  flex: 1 0;
  ${mediaQuery.uptoMobile} {
    display: flex;
    gap: ${Spacings.SPACING_3B};
    align-items: center;
  }
`;

const TileLabel = styled.div`
  width: 70%;
  margin-top: ${Spacings.SPACING_4B};

  ${mediaQuery.uptoMobile} {
    margin-top: 0;
    width: 100%;
    display: contents;
  }
`;

const TileSubLabel = styled.div`
  margin-top: ${Spacings.SPACING_1B};
  width: 90%;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    display: none;
  }
`;

const TileIconWrapper = styled.div`
  display: flex;
`;

const SubWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;
const SubWrapperMweb = styled.div`
  display: none;
  ${mediaQuery.uptoMobile} {
    flex: 1 0;
    display: flex;
    gap: ${Spacings.SPACING_3B};
    align-items: center;
  }
`;

const SubscriptionTilesComponent = ({ tiles, tileImageMapping, goalName }) => {
  const TileIcon = ({ height, width, Component }) => {
    return <Component height={height} width={width} />;
  };

  const getSubscriptionTiles = () => {
    return (
      <TilesWrapper>
        {tiles.map((tile, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <SubscriptionTiles key={i}>
            <SubWrapper>
              <TileIconWrapper>
                <TileIcon
                  height={60}
                  width={i === 0 ? 180 : 60}
                  Component={tileImageMapping[i]}
                />
              </TileIconWrapper>
              <TileLabel>
                <Typography variant="h4">{tile.label}</Typography>
              </TileLabel>
            </SubWrapper>
            <SubWrapperMweb>
              <TileIconWrapper>
                <TileIcon
                  height={40}
                  width={40}
                  Component={tileImageMapping[i]}
                />
              </TileIconWrapper>
              <TileLabel>
                <Typography variant="h5">{tile.label}</Typography>
              </TileLabel>
            </SubWrapperMweb>
            <TileSubLabel>
              <Typography
                as="span"
                variant="p2"
                color="var(--color-text-secondary)"
              >
                {tile.subLabel?.replace('$goal_name', goalName)}
              </Typography>
            </TileSubLabel>
          </SubscriptionTiles>
        ))}
      </TilesWrapper>
    );
  };

  return getSubscriptionTiles();
};

export default SubscriptionTilesComponent;
